<template class="banner">
  <div class="banner-container">
    <div class="content">
      <h1 class="title">
        Acompañamos a IPU Company<br />
        en Las Vegas
      </h1>

      <p class="description">
        Del 23 al 27 de marzo de 2026 acompañaremos a IPU Company en su
        participación en ISC West, una de las ferias internacionales más
        destacadas en tecnología y seguridad, que se realizará en The Venetian
        Expo, Las Vegas. En este importante evento se presentará IPU
        (Intelligent Perception Unit) ante referentes y profesionales del sector
        a nivel global.
      </p>

      <p class="stand">Visítenos en nuestro stand <span>#35097</span></p>

      <button class="cta" @click="openIPU">Conocer IPU</button>
    </div>

    <div class="logos">
      <img src="@/assets/logo_ipu.png" alt="IPU" class="logo-ipu" />
      <img src="@/assets/logo_iscwest.png" alt="ISC West" class="logo-isc" />
    </div>
  </div>
</template>

<script>
export default {
  name: "IpuLasVegasBanner",
  methods: {
    openIPU() {
      window.open("https://ipucompany.com/ar", "_blank");
    },
  },
};
</script>

<style scoped>
.banner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-container {
  width: 100%;
  height: 40rem;
  padding: 3rem 5rem;
  background: #fff;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.content {
  max-width: 775px;
  text-align: left;
}

.title {
  font-size: 2.6rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  color: #111;
}

.description {
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.6;
  margin-bottom: 0.8rem;
  color: #222;
}

.stand {
  font-size: 1rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
}

.stand span {
  color: #e7a900;
}

.cta {
  background: #8c8c8c;
  color: #fff;
  border: none;
  padding: 1rem 2.4rem;
  border-radius: 6px;
  font-weight: 700;
  cursor: pointer;
}

.cta:hover {
  background: #777;
}

.logos {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 13em;
}

.logo-ipu {
  width: 280px;
  object-fit: contain;
}

.logo-isc {
  width: 350px;
  object-fit: contain;
}

@media (max-width: 1024px) {
  .banner-container {
    padding: 2.5rem 2rem;
  }

  .title {
    font-size: 2rem;
  }

  .logo-ipu {
    width: 180px;
  }

  .logo-isc {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .banner-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .logos {
    width: 100%;
    align-items: flex-start;
  }

  .title {
    font-size: 1.8rem;
  }

  .description {
    font-size: 0.9rem;
  }
}
</style>
